import {
  MonitoredProcessData,
  MonitoredProcessDataCreateRequest,
  MonitoredProcessDataUpdateRequest,
} from '../../types/app/monitoredProcessData.types';
import { api } from '../core/api';

export const getMonitoredProcessDatasByDep = (departmentId: number) =>
  api
    .get<MonitoredProcessData[]>(`MonitoredProcessData/GetList/?parentId=${departmentId}`)
    .then((res) => res.data);

export const getMonitoredProcessData = (id: number) =>
  api.get<MonitoredProcessData>(`MonitoredProcessData/GetItem/?id=${id}`).then((res) => res.data);

export const updateMonitoredProcessData = (data: MonitoredProcessDataUpdateRequest) =>
  api.put(`MonitoredProcessData/UpdateItem`, data).then((res) => res.data);

export const createMonitoredProcessData = (data: MonitoredProcessDataCreateRequest) =>
  api.post(`MonitoredProcessData/CreateItem`, data).then((res) => res.data);

export const deleteMonitoredProcessData = (id: number) =>
  api.delete<MonitoredProcessData>(`MonitoredProcessData/DeleteItem/?id=${id}`).then();

export const getCount = (parentId?: number) =>
  api
    .get<number>(`MonitoredProcessData/GetCount` + (parentId ? `?parentId=${parentId}` : ''))
    .then((res) => res.data);
